/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { networkGetNetworkIpinfo } from "../../funcs/networkGetNetworkIpinfo.js";
import { GetNetworkIpinfoRequest$zodSchema } from "../../models/getnetworkipinfoop.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: GetNetworkIpinfoRequest$zodSchema,
};

export const tool$networkGetNetworkIpinfo: ToolDefinition<typeof args> = {
  name: "network-get-network-ipinfo",
  description: `查询 IP

想知道一个IP地址或域名来自地球的哪个角落？这个接口可以帮你定位它。你可以使用默认数据源，也可以指定 \`source=commercial\` 参数来查询更详细的商业级IP归属信息。

## 功能概述
提供一个公网IPv4、IPv6地址或域名，我们会查询并返回它的地理位置（国家、省份、城市）、经纬度、以及所属的运营商（ISP）和自治系统（ASN）信息。这在网络安全分析、访问来源统计等领域非常有用。

当使用 \`source=commercial\` 参数时，接口将调用高性能商业API，提供更精确的市、区、运营商、时区、海拔等信息。请注意，商业查询的响应时间可能会稍长。`,
  scopes: ["read"],
  annotations: {
    "title": "",
    "destructiveHint": false,
    "idempotentHint": false,
    "openWorldHint": true,
    "readOnlyHint": true,
  },
  args,
  tool: async (client, args, ctx) => {
    const [result] = await networkGetNetworkIpinfo(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    return formatResult(result.value);
  },
};
